module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_01.021c9ecc.svg";